// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".lounge-pass-additional-traveller-card[data-v-588f42f7]{display:flex;font-size:1rem;font-weight:400;justify-content:space-between;line-height:1.5rem;margin-bottom:.5rem;--tw-text-opacity:1;color:#282c4a;color:rgba(40,44,74,var(--tw-text-opacity))}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
